import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import InputForm from '../../../../../components/form/InputForm';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { MAXIMUM_NUMBER_OF_RECOMMEND_STORE_SUB_TEXT } from '../../../../../constants/service/app/recommendStoreConstants';
import { setDash } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 브랜드에 연결된 브랜드 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const { isFilter, filterOption, onFilter, form, showSubText, setData } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} filterValue={filterOption.storeId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드 ID 검색'}
          option={filterOption.storeId}
          confirm={confirm}
          onFilter={(storeId) => onFilter({ storeId })}
        />
      ),
      render: (value) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} filterValue={filterOption.storeName} />,
      dataIndex: 'storeName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드명 검색'}
          option={filterOption.storeName}
          confirm={confirm}
          onFilter={(storeName) => onFilter({ storeName })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상점 티어'} />,
      dataIndex: 'storeTier',
      render: (value) => setDash(value),
    },
    {
      title: '서브 텍스트',
      dataIndex: 'subText',
      className: !showSubText && 'not-show-sub-text',
      render: (value, record, index) =>
        showSubText ? (
          <InputForm
            form={form}
            rules={[{ max: MAXIMUM_NUMBER_OF_RECOMMEND_STORE_SUB_TEXT, message: '20자를 초과할 수 없습니다.' }]}
            initialValue={value}
            onChange={(value) =>
              setData({
                path: ['recommendStoreSave', 'recommendStoreItemList', 'selectedItemList', 'list', index],
                value: { ...record, subText: value },
              })
            }
            name={`subText_${record.id}`}
          />
        ) : null,
    },
    {
      title: <TableColumnTitle title={'입점 일자'} />,
      dataIndex: 'entryDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
